// rules.jsx
import React, { useEffect } from 'react';
import './rules.css';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setBackButtonUrl } from '../uiSlice';

function UserRules() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: themeData } = useSelector((state) => state.theme);
  const { status, user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(setBackButtonUrl("/login?&save=true"));
  }, [status, user]);

  const handleNextClick = (e) => {
    e.preventDefault();
    navigate('/game');
  };

  if (!themeData) {
    return (
      <div className='quiz-loader-container'>
        <div className="quiz-loader"></div>
      </div>
    );
  }

  const themeTextColorStyle = { ...(themeData?.text_color && { color: themeData.text_color }) };
  const btnBgColor = themeData?.button_background_color || themeData?.button_backgroundcolor;
  const btnTextColor = themeData?.button_text_color || themeData?.button_color;
  const themeFontSize = Math.min(40, Math.max(12, Number(themeData?.font_size) || 20));

  return (
    <>
      <div className="user-rules-container">
        <div className="user-rules-top">
          <img
            src={process.env.REACT_APP_S3_PATH + themeData?.logo}
            alt="Cubicle Chaos"
            className="user-rules-image"
          />
        </div>
        <div className="user-rules-bottom">
          <div
            className="user-rules-big-title"
            style={{ ...themeTextColorStyle, fontSize: `${themeFontSize + 12}px` }}
          >
            {themeData?.main_title}
          </div>
          {/* <div className="user-rules-subline">
            {themeData?.landing_page_title}
          </div> */}
          <div className="user-rules-heading" style={{
                ...(btnBgColor && { backgroundColor: btnBgColor }),
                ...(btnTextColor && { color: btnTextColor }),
                fontSize: `${themeFontSize}px`,
              }}>Pick your vibe, we’ll find your people 👀</div>
          <ul className="user-rules-list" style={{ ...themeTextColorStyle, fontSize: `${themeFontSize}px` }}>
            {
              (Array.isArray(themeData?.rules) ? themeData.rules : []).map((rules, index) => (
                <li key={index}>
                  <i
                    className="fa fa-arrow-right user-rule-icon"
                    aria-hidden="true"
                  />
                  {rules}
                </li>
              ))
            }
          </ul>
          <div style={{ textAlign: "center" }}>
            <button style={{
                ...(btnBgColor && { backgroundColor: btnBgColor }),
                ...(btnTextColor && { color: btnTextColor }),
                fontSize: `${themeFontSize}px`,
              }}
              className="user-next-button"
              onClick={handleNextClick}
            >
              Start
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default UserRules;
